import { PATH_ROOT } from "@/constants";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export function useContractorsPlannedHoursWizardBreadcrumbItems() {
  const { t } = useTranslation();

  return useMemo(
    () => [
      { label: t("breadcrumb.home"), href: PATH_ROOT },
      { label: t("navigation.contractorsPlannedHoursWizard") },
    ],
    [t],
  );
}
